import router from 'app/router'

export default {

    namespaced: true,

    state: {

        game: 0

    },

    getters: {

        active: function() {

            return {}

        },

        values: function(state) {

            return {
                'game': state.game
            }

        },

        game: function(state) {

            return state.game

        }

    },

    mutations: {

        reset: function(state) {

            state.game = 0

        },

        game: function(state, value) {

            state.game = value

        }

    },

    actions: {

        analyse: function(context) {

            return new Promise(function(resolve) {

                context.commit('reset')

                context.state.game = parseInt(router.currentRoute.params.game) || 0

                resolve()

            })

        },

        route: function() {

            var urlParams = {}

            router.replace({name: 'InsightsGame', query: urlParams}).catch(function() {})

        }

    }

}
